import { ContextsSymbol } from '../index';
var isActionWithContexts = function isActionWithContexts(action) {
  return !!(action !== null && action !== void 0 && action[ContextsSymbol]);
};
export var extractContextsFromAction = function extractContextsFromAction(action) {
  return isActionWithContexts(action) ? action[ContextsSymbol] : undefined;
};